// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___33Y1","label":"styles_label__Lo6Ns"};